import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Menu, Icon } from "antd";

import { downloadFile } from "../../shared/utilities/fileDownloader";

const AttachmentsList = ({ files }) => {
    const buildMenu = () => {
        var menuOptions = JSON.parse(files).map(file => (
            <Menu.Item>
                <Link to="#" onClick={() => downloadFile(file.Nome, file.Caminho)}>
                    {file.Nome}
                </Link>
            </Menu.Item>
        ));

        return <Menu>{menuOptions}</Menu>;
    };

    return (
        <Dropdown overlay={buildMenu()} placement="bottomLeft">
            <Link to="#" className="opcao-player-anexos" title="Anexos">
                <Icon type="paper-clip" />
            </Link>
        </Dropdown>
    );
};

export default AttachmentsList;
